import { useState } from "react";
import { AddFont } from "./create-font";
import Papa from "papaparse";
import { Parser } from "json2csv";
import { useHistory } from "react-router-dom";
import { getBulkDownloadCSV } from "../../services/axios";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
var uuid = require("uuid");

export const Admin = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  let [file, setFile] = useState<any>(null);
  let [selectedCollection, setSelectedCollection] = useState("galleryimages");

  async function downloadData() {
    const dateTime = new Date().toISOString().replace(/\W/g, "");
    const filename = `${selectedCollection}_${dateTime}.csv`;
    const url = await getBulkDownloadCSV(
      `table=${selectedCollection}&start=${startDate.getTime()}&end=${endDate.getTime()}`
    );
    var link = document.createElement("a");
    link.setAttribute("type", "hidden"); // make it hidden if needed
    link.download = filename;
    link.href = url.url; //+'&charset=utf-8';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  const handleUploadChange = (e: any) => {
    setFile(e.target.files[0]);
  };

  function chunkArrayInGroups(arr: any[], size: number) {
    var myArray = [];
    for (var i = 0; i < arr.length; i += size) {
      myArray.push(arr.slice(i, i + size));
    }
    return myArray;
  }

  const uploadFile = async (
    file: File,
    rowCount: number,
    randomname: string,
    index: number
  ) => {
    // todo: update to api
    // try {
    //   const snapshot = await firebase
    //     .storage()
    //     .ref(randomname)
    //     .put(file as File);
    //   const downloadURL = await snapshot.ref.getDownloadURL();
    //   console.log(`file chunk number ${index} available at`, downloadURL);
    //   await firebase.firestore().collection("upload-queue").add({
    //     status: "scheduled",
    //     url: downloadURL,
    //     filename: randomname,
    //     collection: selectedCollection.toLowerCase(),
    //     created_at: new Date(),
    //     updated_at: new Date(),
    //   });
    // } catch (e) {
    //   console.log(e);
    // }
  };

  const handleUpload = async (file: any) => {
    Papa.parse(file as File, {
      header: true,
      worker: true, // Don't bog down the main thread if its a big file
      complete: function (results, f) {
        const chunks = chunkArrayInGroups(results.data, 500);
        for (let i = 0; i < chunks.length; i++) {
          const json2csvParser = new Parser();
          const csv = json2csvParser.parse(chunks[i]);
          const randomname = uuid.v4();
          var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
          var file = new File([blob], `${randomname}.csv`);
          uploadFile(file, chunks[i].length, `${randomname}.csv`, i);
        }
      },
    });
  };

  const handleSelectChange = (value: any) => {
    setSelectedCollection(value.target.id);
  };

  const collectionNames = [
    {
      id: "galleryimages",
      title: "Gallery Images",
    },
    {
      id: "proofimages",
      title: "Proof Images",
    },
    {
      id: "printfiles",
      title: "Print Files",
    },
  ];

  return (
    <div className="h-full bg-white">
      <div
        className="relative h-full text-lg max-w-7xl mx-auto"
        aria-hidden="true"
      >
        <div className="relative px-4 sm:px-6 lg:px-8 my-6 grid grid-cols-2">
          <div className="relative px-4 sm:px-6 lg:px-8 my-6 grid grid-cols-1 gap-4 border-r pr-8">
            <label className="text-base font-medium text-gray-900">
              Collections
            </label>
            <p className="text-sm leading-5 text-gray-500">
              Which collection do you want to download?
            </p>
            <fieldset className="mt-4">
              <legend className="sr-only">collection name</legend>
              <div className="space-y-4">
                {collectionNames.map((notificationMethod, index) => (
                  <div key={index} className="flex items-center">
                    <input
                      id={notificationMethod.id}
                      name="notification-method"
                      type="radio"
                      defaultChecked={notificationMethod.id === "galleryimages"}
                      className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-500"
                      onClick={handleSelectChange}
                    />
                    <label
                      htmlFor={notificationMethod.id}
                      className="ml-3 block text-sm font-medium text-gray-700"
                    >
                      {notificationMethod.title}
                    </label>
                  </div>
                ))}
              </div>
            </fieldset>
            <div className="text-lg">
              <div className="grid grid-cols-2 gap-2 mb-4">
                <div>
                  <p>Start Date</p>
                  <Calendar onClickDay={setStartDate} value={startDate} />
                </div>
                <div>
                  <p>End Date</p>
                  <Calendar onClickDay={setEndDate} value={endDate} />
                </div>
              </div>
            </div>
            <button
              onClick={downloadData}
              type="button"
              className="mb-8 inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Download
            </button>
            {/* <input
              className="w-full pb-6"
              type="file"
              onChange={handleUploadChange}
            /> */}
          </div>
          <div className="relative px-4 sm:px-6 lg:px-8 my-6">
            <div className="text-lg max-w-prose mx-auto">
              <AddFont />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
